import { createCancellableRequest } from '../axios.js'

/**
 * Widget MDAQ
 * @param {Object} params
 * @param {Number} params.quantity - Quantity to be displayed, for example: 1,2,5,10,25
 * @param {String} params.unit - Unit to be displayed, for example: ‘gram’ or ‘toz’
 * @returns {Promise} - Axios response Promise
 */
export const getWidget = (params) => {
	const { request, cancel } = createCancellableRequest()

	const promise = () => request({
		url: '/v2.1/igx/widget',
		method: 'GET',
		params: params
	})


	return {
		promise,
		cancel,
	}
}